import { useState } from 'react'
import { auth, db } from "../firebase/FirebaseConfig";
import { useAuthContext } from './useAuthContext'
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, collection, updateDoc } from 'firebase/firestore';

export const useLogin = () => {
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()

  const login = async (email, password) => {
    setError(null)
    setIsPending(true)
  
    try {
      // login
      const res = await signInWithEmailAndPassword(auth, email, password)

      // change the online property
    //   const collRef = collection(db, 'users')
    //   const userDocRef = doc(collRef, res.user.uid)
    //   await updateDoc(userDocRef, { online: true })

      // dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user })
      setIsPending(false)
      setError(null)

    } 
    catch(err) {
      setError(err.message)
      setIsPending(false)

    }
  }


  return { login, isPending, error }
}